<template>
<div>
  <Row :gutter="10">
    <Col :span="12">
      <Card><div id="typeConsist"></div></Card>
    </Col>
    <Col :span="12">
      <Card><div id="statusConsist"></div></Card>
    </Col>
  </Row>
  <Row :gutter="10" style="padding-top: 10px;">
    <Col :span="12">
      <Card><div id="originConsist"></div></Card>
    </Col>
    <Col :span="12">
      <Card><div id="formConsist"></div></Card>
    </Col>
  </Row>
</div>
</template>

<script>
import echarts from 'echarts'
import { ListQueryConsist } from '@/api/stat'

export default {
  name: 'subject-consist',
  data: function () {
    return {
      height: '160px',
      tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b} : {c} ({d}%)'
      }
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init: function () {
      const id = this.$route.params.id
      ListQueryConsist(id).then(async res => {
        this.drawConsist('statusConsist', '疑问状态', res.status)
        this.drawConsist('typeConsist', '疑问类型', res.type)
        this.drawConsist('originConsist', '疑问来源', res.origin)
        this.drawConsist('formConsist', '所属表单', res.form)
      })
    },
    drawConsist: function (id, title, res) {
      var opts = {
        width: 'auto',
        height: '360px'
      }
      this.echarts = echarts.init(document.getElementById(id), 'light', opts)
      var options = {
        title: {
          text: title + '构成',
          x: 'center'
        },
        tooltip: this.tooltip,
        legend: {
          orient: 'vertical',
          left: 'left',
          data: res.legends
        },
        series: {
          name: title,
          type: 'pie',
          radius: '72%',
          data: res.series
        }
      }
      this.echarts.setOption(options)
    }
  }
}
</script>
